import { ScanSearch, Blocks, UsersRound } from "lucide-react";

import Section from "@/components/Section";
import Container from "@/components/Container";
import Eyebrow from "@/components/Eyebrow";
import Reveal from "@/components/Reveal";
import { PathCard } from "@/components/home/PathCard";

const PATHS = [
  {
    icon: ScanSearch,
    eyebrow: "01",
    title: "I don't know where AI fits",
    body: "You know it matters. You don't know which part of your business it applies to, or what it's worth. That's the assessment.",
    items: [
      "Operations mapped end to end",
      "Opportunities ranked by payback",
      "A sequenced starting plan",
    ],
    cta: "Find the opportunities",
    to: "/services/ai-opportunity-assessment",
  },
  {
    icon: Blocks,
    eyebrow: "02",
    title: "I know what I want to build",
    body: "You've identified the use case. You need it built properly, integrated with what you already run, and actually shipped.",
    items: [
      "Systems built and deployed",
      "Integrated with your existing tools",
      "In production, not a pilot",
    ],
    cta: "Build it",
    to: "/services/ai-implementation",
  },
  {
    icon: UsersRound,
    eyebrow: "03",
    title: "We built it and nobody uses it",
    body: "The hardest part of AI adoption isn't the technology. It's the week your team quietly goes back to the old way.",
    items: ["Adoption diagnosis", "Role-specific training", "Change management that sticks"],
    cta: "Fix adoption",
    to: "/services/ai-enablement",
  },
] as const;

export function ThreePaths() {
  return (
    <Section tone="paper">
      <Container>
        <div className="max-w-[60ch]">
          <Eyebrow>Where are you with AI right now?</Eyebrow>
          <h2 className="mt-3 font-display text-h2 text-ink-900">
            Pick the closest fit. We&rsquo;ll take it from there.
          </h2>
        </div>

        <Reveal className="mt-12 grid grid-cols-1 gap-6 min-[900px]:grid-cols-3">
          {PATHS.map((path, i) => (
            <PathCard key={path.title} {...path} accent={i === 2 ? "violet" : "brand"} />
          ))}
        </Reveal>
      </Container>
    </Section>
  );
}

export default ThreePaths;
